export const QUICK_LINKS = [
    { label: "How it works", href: "https://www.heritageinschools.ie/about/how-it-works" },
    { label: "FAQs", href: "https://www.heritageinschools.ie/about/faqs" },
    { label: "Search for a Specialist", href: "https://www.heritageinschools.ie/heritage-expert/search-for-an-expert" },
    { label: "Teachers` Resources", href: "https://www.heritageinschools.ie/teachers-resources" },
    { label: "Places to Visit", href: "https://www.heritageinschools.ie/places-to-visit" },
    { label: "Children & the Outdoors", href: "https://www.heritageinschools.ie/children-the-outdoors" }
];


export const BOTTOM_LINKS = [
    { label: "Privacy Statement", href: "https://www.heritageinschools.ie/about/privacy-statement" },
    { label: "Cookie Policy", href: "https://www.heritageinschools.ie/about/cookie-privacy-policy" },
    { label: "Disclaimer", href: "https://www.heritageinschools.ie/about/disclaimer" },
    { label: "Sitemap", href: "https://www.heritageinschools.ie/sitemap" },
];
